export const SELECTION_SUMMARY = 'selectionSummary';
export const HIGHLIGHT_SUMMARY = 'highlightSummary';
